var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneric04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12136_1295)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#B3F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3622 20.3334H24.3046L25.1916 25.471C25.3217 26.2245 25.5956 26.9459 25.9984 27.5959C26.0476 27.6753 25.9905 27.7778 25.8971 27.7778H13.7106C13.6441 27.7778 13.6043 27.7039 13.6409 27.6484C14.0909 26.965 14.3924 26.1947 14.526 25.3874L15.3622 20.3334Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4445 22.5555C13.4445 21.5737 14.2404 20.7778 15.2222 20.7778H24.6667C25.6485 20.7778 26.4445 21.5737 26.4445 22.5555C26.4445 23.5374 25.6485 24.3333 24.6667 24.3333H15.2222C14.2404 24.3333 13.4445 23.5374 13.4445 22.5555Z",
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6667 21.1111H15.2222C14.4245 21.1111 13.7778 21.7578 13.7778 22.5555C13.7778 23.3533 14.4245 24 15.2222 24H24.6667C25.4644 24 26.1111 23.3533 26.1111 22.5555C26.1111 21.7578 25.4644 21.1111 24.6667 21.1111ZM15.2222 20.7778C14.2404 20.7778 13.4445 21.5737 13.4445 22.5555C13.4445 23.5374 14.2404 24.3333 15.2222 24.3333H24.6667C25.6485 24.3333 26.4445 23.5374 26.4445 22.5555C26.4445 21.5737 25.6485 20.7778 24.6667 20.7778H15.2222Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05225 45.2859C6.19166 38.7972 9.94345 32.0288 16.4321 30.1682C22.9208 28.3076 29.6892 32.0594 31.5498 38.5481L31.9479 39.9365C33.8085 46.4252 30.0567 53.1936 23.568 55.0542C17.0794 56.9148 10.311 53.163 8.45039 46.6743L8.05225 45.2859Z",
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6275 40.0284L31.2293 38.6399C29.4195 32.3282 22.8357 28.6788 16.524 30.4886C10.2123 32.2985 6.56282 38.8823 8.37267 45.194L8.77081 46.5825C10.5807 52.8942 17.1645 56.5436 23.4762 54.7338C29.7879 52.9239 33.4373 46.3401 31.6275 40.0284ZM16.4321 30.1682C9.94345 32.0288 6.19166 38.7972 8.05225 45.2859L8.45039 46.6743C10.311 53.163 17.0794 56.9148 23.568 55.0542C30.0567 53.1936 33.8085 46.4252 31.9479 39.9365L31.5498 38.5481C29.6892 32.0594 22.9208 28.3076 16.4321 30.1682Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2222 26.8889H23.3333V30.4445H16.2222V26.8889Z",
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9999 27.2222H16.5555V30.1111H22.9999V27.2222ZM16.2222 26.8889V30.4445H23.3333V26.8889H16.2222Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5557 26.8889H23.0001V31.3334H16.5557V26.8889Z",
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 17.6111C14.6667 14.6963 17.0297 12.3333 19.9445 12.3333C22.8594 12.3333 25.2223 14.6963 25.2223 17.6111V23.5C25.2223 26.4148 22.8594 28.7778 19.9445 28.7778C17.0297 28.7778 14.6667 26.4148 14.6667 23.5V17.6111Z",
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.889 23.5V17.6111C24.889 14.8803 22.6753 12.6666 19.9445 12.6666C17.2138 12.6666 15.0001 14.8803 15.0001 17.6111V23.5C15.0001 26.2307 17.2138 28.4444 19.9445 28.4444C22.6753 28.4444 24.889 26.2307 24.889 23.5ZM19.9445 12.3333C17.0297 12.3333 14.6667 14.6963 14.6667 17.6111V23.5C14.6667 26.4148 17.0297 28.7778 19.9445 28.7778C22.8594 28.7778 25.2223 26.4148 25.2223 23.5V17.6111C25.2223 14.6963 22.8594 12.3333 19.9445 12.3333Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18.7778H15.8889L15 20.8889V18.7778Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8889 18.7778H24L24.8889 20.8889V18.7778Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8739 31.2222C25.6553 32.9516 23.0842 34.3165 19.9445 34.3165C16.823 34.3165 14.2635 32.9674 14.0191 31.2522C9.83794 32.4497 6.77783 36.3009 6.77783 40.8669V48.4224H33.2223V40.8669C33.2223 36.2621 30.1098 32.3842 25.8739 31.2222Z",
    fill: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1595 33.7131C23.0416 34.2995 21.5591 34.6498 19.9445 34.6498C18.3392 34.6498 16.8646 34.3035 15.7491 33.7233C14.7843 33.2214 14.0437 32.5183 13.7754 31.6755C9.90627 32.9385 7.11117 36.5767 7.11117 40.8669V48.0891H32.8889V40.8669C32.8889 36.5394 30.045 32.8753 26.1237 31.6431C25.866 32.4947 25.1265 33.2058 24.1595 33.7131ZM25.8038 31.5487C25.3248 33.1203 22.8838 34.3165 19.9445 34.3165C17.0232 34.3165 14.5941 33.1349 14.0943 31.5775C14.06 31.4707 14.0348 31.3623 14.0191 31.2522C13.911 31.2832 13.8036 31.316 13.697 31.3504C9.68171 32.6494 6.77783 36.419 6.77783 40.8669V48.4224H33.2223V40.8669C33.2223 36.3801 30.2673 32.5834 26.1973 31.3169C26.0902 31.2836 25.9824 31.252 25.8739 31.2222C25.8599 31.3326 25.8364 31.4415 25.8038 31.5487Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1492 16.1867C14.1492 14.8018 15.0055 13.5612 16.3003 13.07L16.8476 12.8625C18.8786 12.0921 21.1215 12.0921 23.1525 12.8625L23.6998 13.07C24.9946 13.5612 25.8509 14.8018 25.8509 16.1867V19.3334H14.1492V16.1867Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5176 19V16.1867C25.5176 14.9403 24.7469 13.8237 23.5815 13.3817L23.0343 13.1741C21.0794 12.4326 18.9207 12.4326 16.9658 13.1741L16.4185 13.3817C15.2532 13.8237 14.4825 14.9403 14.4825 16.1867V19H25.5176ZM16.3003 13.07C15.0055 13.5612 14.1492 14.8018 14.1492 16.1867V19.3334H25.8509V16.1867C25.8509 14.8018 24.9946 13.5612 23.6998 13.07L23.1525 12.8625C21.1215 12.0921 18.8786 12.0921 16.8476 12.8625L16.3003 13.07Z",
    fill: "#111111"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12136_1295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric04);
export default __webpack_public_path__ + "static/media/Generic 04.52bccd41f6d4da020ff6817d99ba4844.svg";
export { ForwardRef as ReactComponent };